import { FC } from 'react';
import { DealDocStatusBadge } from '../../CompanyProfiles/components/ActivityDrawer/DealDocs/DealDocStatusBadge';
import {
  containerCss,
  detailCss,
  listCountCss,
  listCss,
  listHeaderCss,
  sidebarCss,
} from './CompanyDealsView';
import { DealRoundCardView } from './DealRoundCard';
import { detailStackCss } from './DealRoundDetail';
import {
  PREVIEW_ROUNDS,
  PREVIEW_STAGE_LABELS,
  PREVIEW_STAGES,
  PREVIEW_TRANSACTION_ROWS,
  previewHighestPps,
} from './dealsTab.fixtures';
import { RoundDocumentsPreview } from './RoundDocumentsPreview';
import { RoundGovernancePreview } from './RoundGovernancePreview';
import { RoundOverviewCardView } from './RoundOverviewCard';
import { RoundSecurityGrid } from './RoundSecurityGrid';
import { RoundTransactionGridView } from './RoundTransactionGrid';

const ignore = () => undefined;

/** Sample-data stand-in for the whole Deals tab while it is frosted: the newest round selected. */
export const DealsTabPreview: FC = () => {
  const selected = PREVIEW_ROUNDS[0];
  return (
    <div css={containerCss}>
      <div css={sidebarCss}>
        <div css={listHeaderCss}>
          <span>Financing Rounds</span>
          <span css={listCountCss}>{PREVIEW_ROUNDS.length}</span>
        </div>
        <div css={listCss} role='group' aria-label='Financing rounds'>
          {PREVIEW_ROUNDS.map((round) => (
            <DealRoundCardView
              key={round.id}
              round={round}
              isSelected={round.id === selected.id}
              onSelect={ignore}
              stage={PREVIEW_STAGES[round.id]}
              status={<DealDocStatusBadge status='data_extracted' />}
            />
          ))}
        </div>
      </div>
      <div css={detailCss} role='region' aria-label='Round details'>
        <div css={detailStackCss}>
          <RoundOverviewCardView
            round={selected}
            stageLabel={PREVIEW_STAGE_LABELS[selected.id]}
            highestPps={previewHighestPps(selected)}
          />
          <RoundGovernancePreview />
          <RoundSecurityGrid round={selected} />
          <RoundTransactionGridView rows={PREVIEW_TRANSACTION_ROWS} />
          <RoundDocumentsPreview />
        </div>
      </div>
    </div>
  );
};
